export default "__VITE_ASSET__FSbtMwNI__"